import { User } from 'src/app/shared/models/user.model';
import { Component, OnInit, Output, EventEmitter, Input, ElementRef  } from "@angular/core";
import { FormGroupDirective, UntypedFormGroup, Validators, UntypedFormBuilder } from "@angular/forms";
import { AppConstants } from 'src/app/app.constants';
import { DocumentsRepositoryService } from "../../services/documents-repository.service";
import{  DocumentsDetailsRawData, DocumentsTypeByPath, FirstItem, SupplierDetails, GetDocumentTypesRequest, FileUploadPathByDocumentType, AdditionalInformation, GetFilePathByDocumentType, GetMaterialMetaData} from "src/app/shared/models/documents.model"
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { fileExtensionValidator } from "../directive/file-extension-validator.directive";
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import moment from 'moment';
import {MatChipInputEvent} from '@angular/material/chips';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

export interface documentTag {
  name: string;
}

export const DATE_PICKER = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class DynamicFormFieldModel {
  id: string;
  type: 'text' | 'select' | 'date' | 'autocomplete' | 'checkbox' | 'number';
  label: string;
  hint?:string;
  list?:string[];
  maxLength?:string
}

@Component({
  selector: "app-upload-documents",
  templateUrl: "./upload-documents.component.html",
  styleUrls: ["./upload-documents.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: DATE_PICKER },
  ],
})

export class UploadDocumentsComponent implements OnInit {
  @Input() supplierInfo: SupplierDetails;
  @Input() suppliers: SupplierDetails[];  
  @Output() changeHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() tagsHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() docTypeSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() breadCrumb: string[];
  @Input() isUserSupplier: boolean;
  @Input() foldersGrid: boolean;
  @Input() editUploadedfile: boolean;

  doctTypeWarning: boolean;
  suffixWarning: boolean;
  invalidDocType: boolean;
  mutipleFilesNotAllowed: boolean;
  fileSizeValid: boolean;
  editFileMode: boolean;
  invalidMaterial:boolean=false;
  hasPermissions: boolean = true; 
  additionalInformation: boolean = true;
  isAdditionalInformationBlock: boolean = false;
  isDocTypeLoading: boolean = false;
  fileList = [];
  selectedDocTypes: FirstItem[];
  fileSize: any;
  generatedDocumentNameValue: string;
  acceptedFileExtensions: string;
  uploadFileName: string = "";
  filePathToUpload: string = "";
  DATETYPE: string = 'date';
  materialList: string[];
  materialListCopy: string[];
  namingConvention:string;
  SPECIALCHAR: string = "^[-,:a-zA-Z0-9]*$";
  SPECIALCHARSN: string = "^[- ,:a-zA-Z0-9]*$";
  SPECIALCHARRevN: string = "^[.,a-zA-Z0-9]*$";
  MAINFOLDERS: string = "Main Folders";
  specialCharMsg: string = AppConstants.specialCharSuffixHLB;
  specialCharMsgSnPo: string = AppConstants.specialCharSNPO;
  suffixWarningMsg: string = AppConstants.suffixWarningMsg;
  doctTypeWarningMsg: string = AppConstants.doctTypeWarningMsg;
  loggedUserDetails: User;
  docTypesByPath: DocumentsTypeByPath;
  isArrowUpOrDown = true;
  editFileDetailsChildComponents: DocumentsDetailsRawData;
  uploadFileForm!: UntypedFormGroup;
  tooltipOptions: Object; 
  additionalInfoObj: AdditionalInformation = new AdditionalInformation();
  allSuppliers: SupplierDetails[];
  dynamicFormFields!: DynamicFormFieldModel[];
  private unsubscribe: Subject<void> = new Subject<void>();
  private filePathData: GetDocumentTypesRequest = new GetDocumentTypesRequest();
  /*--material chips start ---*/
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  documentTag = [];
  tagValueSize: boolean = false;
  tagLengthSize: boolean = false;
  isCommonControlsAvailable: boolean;
  isEditCommonControls: boolean = false;
  dynamicCommonFormFields: any = [];
  /*--material chips end ---*/

  constructor(
    private rootFormGroup: FormGroupDirective,
    private documentsService: DocumentsRepositoryService,
    private adminRepository: AdminRepositoryService,
    private el: ElementRef,
    private userRepositoryService: UserRepositoryService,
    private fb: UntypedFormBuilder
  ) {
    this.tooltipOptions = {
      placement: "top",
      "show-delay": "1",
      "hide-delay": "1",
      "tooltip-class": "sg-tooltip-upload",
      tooltipClass: "sg-tooltip-upload",
      pointerEvents: "none",
    };
  }

  ngOnInit(): void {
    if (!this.breadCrumb) {
      this.breadCrumb = [this.MAINFOLDERS];
    }
    this.uploadFileForm = this.rootFormGroup.control;
    this.uploadFileForm.controls.tags.valueChanges.subscribe(
      (selectedValue) => {
        if (selectedValue) {
          this.tagsHandler.emit(this.documentTag);
        }
      });
  }

  onDocTypeSelected(event: MatAutocompleteSelectedEvent) {
    const selectedValue = event.option.value;
    this.docTypeSelected.emit(selectedValue);

    this.selectedDocTypes = this.docTypesByPath.item2.filter(
      (item) => item.displayValue === selectedValue
    );
    this.showCommonControls();

    if (this.selectedDocTypes.length > 0) {
      this.isDocTypeLoading = true;
      let data: GetFilePathByDocumentType = new GetFilePathByDocumentType();
      data.supplierId = this.supplierInfo.id;
      data.documentType = this.selectedDocTypes[0].documentTypeString;
      this.getUploadPathByDocumentType(data);
    }
  }

  showCommonControls() {
    this.resetDynamicCommonFormFields(); 
    if(this.selectedDocTypes[0]) {
      let tempControlName: any; 
      let controlsDetails: any;
      let controlsName: any;
      let tempCtrlValue: any;
      let commonAttributes:any= this.selectedDocTypes[0].commonControlAttributes; 
      this.isCommonControlsAvailable = true;

      commonAttributes.forEach(formItem => {  
        if(formItem) {   
        controlsDetails=new DynamicFormFieldModel ()
        const controlFirstWord=formItem.controlName.split(' ')[0]; //.toLowerCase();
        if(controlFirstWord == 'Expiration') {
         tempControlName = formItem.controlName.split(' ');
         tempControlName[1]= tempControlName.length > 1 ? tempControlName[1].charAt(0).toUpperCase() + tempControlName[1].slice(1) : '';
        
        } else {
          tempControlName = formItem.controlName;
          tempCtrlValue = formItem.controlDetail.controlData.data[0] == 'true' ? true : false;
        }
        controlsName = tempControlName == 'IsIntegratedWithSSS' ? 'common'+tempControlName : 'common'+tempControlName.join('');
        const controlsNameId = tempControlName == 'IsIntegratedWithSSS' ? 'common'+tempControlName : 'common'+tempControlName.join('');
        controlsDetails.id=controlsNameId;
        controlsDetails.type=formItem.controlDetail.controlType;
        controlsDetails.label= tempControlName == 'IsIntegratedWithSSS' ? tempControlName : tempControlName.join(' ');
        controlsDetails.hint=formItem.controlDetail.controlHint == null ? '' : formItem.controlDetail.controlHint;
        controlsDetails.maxLength=formItem.controlDetail.maxLength == null ? '' : formItem.controlDetail.maxLength;
        //controlsDetails.list=formItem.controlDetail.controlData?formItem.controlDetail.controlData.data:''
        this.dynamicCommonFormFields.push(controlsDetails);   
        }   
      });

      this.dynamicCommonFormFields.forEach(formItem => {
        this.uploadFileForm.addControl(formItem.id, this.fb.control(       
          formItem.type==='text'|| formItem.type === 'Checkbox' ||
          formItem.type==='date' ?'':null));
          if (formItem.type === 'Checkbox') {
            this.uploadFileForm.controls[formItem.id].setValue(tempCtrlValue);
          }
          
      });
    }

    if (this.isEditCommonControls) {
      this.dynamicCommonFormFields.forEach(formItem => {
        if (formItem.type === this.DATETYPE) {
         let allDates = this.editFileDetailsChildComponents.uiDocumentAttributesDTO.documentAttributes.additionalInformation[formItem.id];
         const formetDate = allDates ?  moment(allDates).format("MM/DD/YYYY HH:mm:ss") : '';
         const currentDate = formetDate ? new Date(formetDate) : '';
         this.uploadFileForm.controls[formItem.id].patchValue(currentDate);
        } 


        // else {
        //   this.uploadFileForm.controls[formItem.id].patchValue(this.editFileDetailsChildComponents.uiDocumentAttributesDTO.documentAttributes.additionalInformation[formItem.id])
        // }
      })
    } else {
      this.dynamicCommonFormFields.forEach(formItem => {
        if (formItem.type === this.DATETYPE) {
         // this.uploadFileForm.controls[formItem.id].patchValue('');
          this.uploadFileForm.controls[formItem.id].reset('');
        }
      });
    }
  }

  onUploadclicked(): void {
    this.getLogedUser();
    this.dynamicFormFields=[];    
    this.isAdditionalInformationBlock=false;
    this.addRemoveValidators();
    this.formOnChange();
    //this.getMaterialList();
    this.invalidDocType = false;
    this.uploadFileForm.controls.supplier.patchValue(this.supplierInfo);
    //this.uploadFileForm.controls.tags.patchValue(this.documentTag);
  }

  toggleShow(): void {
    this.additionalInformation = !this.additionalInformation;
  }

  onFileDropped($event): void {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(files): void {
    this.prepareFilesList(files);
  }

  prepareFilesList(files): void {
    this.mutipleFilesNotAllowed = false;
    this.fileList = files;
    if (this.fileList.length > 1) {
      this.fileList = [];
      this.mutipleFilesNotAllowed = true;
      this.uploadFileName = "";
      this.uploadFileForm.controls.documentName.setValue("");
      return;
    }
    this.validateFileSize();
    this.changeHandler.emit(this.fileList[0]);
    this.uploadFileName = this.fileList[0].name;
    if (
      !this.uploadFileForm.controls.filesToUpload.value &&
      this.fileList[0].name
    ) {
      this.uploadFileForm.controls.filesToUpload.clearValidators();
      this.uploadFileForm.controls.filesToUpload.updateValueAndValidity();
    }
    this.uploadFileForm.controls.documentName.setValue(this.fileList[0].name);
  }

  validateFileSize(): void {
    this.adminRepository.getfileSize()
    .pipe(takeUntil(this.unsubscribe))
    .subscribe((response) => {
      this.fileSize= response;
           const fileSize = this.fileList[0].size;
           const fileSizeInKB = Math.round(fileSize / 1024);
           const fileSizeInMB = Math.round(fileSizeInKB / 1024);
           const maxFileSizeInMB = Number(response);
            fileSizeInMB >= maxFileSizeInMB
            ? (this.fileSizeValid = true)
            : (this.fileSizeValid = false);
          }
        );
}

  getDocumentsTypesBypath(filePathData: GetDocumentTypesRequest): void {
    this.documentsService
      .getDocumentTypesByPath(filePathData)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (docTypesByPath: DocumentsTypeByPath) => {
          if(docTypesByPath) {
          this.docTypesByPath = docTypesByPath;
          docTypesByPath.item2 = docTypesByPath.item2;
          this.breadCrumb.length > 1
            ? (docTypesByPath.filterList = docTypesByPath.item1)
            : (docTypesByPath.filterList = docTypesByPath.item2);
          if (
            this.editFileDetailsChildComponents?.uiDocumentAttributesDTO
              ?.documentAttributes?.documentType &&
            this.editFileMode
          ) {
            this.selectedDocTypes = this.docTypesByPath.item2.filter(
              (item) =>
                item.documentTypeString ===
                this.editFileDetailsChildComponents.uiDocumentAttributesDTO
                  .documentAttributes.documentType
            );
            this.uploadFileForm.controls.documentType.patchValue(
              this.selectedDocTypes[0]?.displayValue
            );
           // this.showAdditionalInformation();
          }
        }
        },
        (err) => {
          console.error(err);
        }
      );
  }

  generateFolderPath(): void {
    this.filePathData.folderPath = this.breadCrumb[0];
    if (this.breadCrumb.length > 1) {
      this.filePathData.folderPath = `${this.breadCrumb[1]}`;
    } else if (this.breadCrumb.length > 2) {
      this.filePathData.folderPath = `${this.breadCrumb[1]}\\${this.breadCrumb[2]}`;
    }
  }

  addRemoveValidators(): void {
    this.editFileDetailsChildComponents && this.editFileMode
      ? this.uploadFileForm.controls.filesToUpload.clearValidators()
      : this.uploadFileForm.controls.filesToUpload.setValidators([
          Validators.required,
          fileExtensionValidator(this.acceptedFileExtensions),
        ]);
    this.uploadFileForm.controls.filesToUpload.updateValueAndValidity();
  }

  formOnChange(): void {
    this.uploadFileForm.controls.documentType.valueChanges.subscribe(
      (selectedValue) => {
        if (!this.docTypesByPath || !Array.isArray(this.docTypesByPath.item2)) {
          this.invalidDocType = true;
          this.filePathToUpload = "";
          return;
        }

        this.invalidDocType = false;
        if (selectedValue) {
          this.searchaDocTypeByUserInput(selectedValue);
        } else if (this.docTypesByPath) {
          this.docTypesByPath.filterList = this.breadCrumb.length > 1
            ? this.docTypesByPath.item1
            : this.docTypesByPath.item2;
        }
        this.doctTypeWarning = true;
      }
    );
    this.uploadFileForm.controls.searchBox.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        if (value) {
          this.suppliers = this.suppliers.filter(
            (x) =>
              x.supplierName
                .toString()
                .toLowerCase()
                .indexOf(value.toString().toLowerCase()) > -1
          );
        } else if (this.suppliers.length === 0 && value) {
          this.suppliers = this.suppliers.filter(
            (x) =>
              x.organizationCode
                .toString()
                .toLowerCase()
                .indexOf(value.toString().toLowerCase()) > -1
          );
        } else {
          this.suppliers = this.allSuppliers;
        }
      });

    this.uploadFileForm.controls.supplier.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {              
        if(this.supplierInfo){
          this.filePathData.supplierId=this.supplierInfo.id
          this.getDocumentsTypesBypath(this.filePathData);
          this.generateFolderPath();
        }
      });

     
  };

  showAdditionalInformation() {
    this.resetDynamicFormFields()
    let controlAttributes:any= this.selectedDocTypes[0].controlAttributes; 
    this.namingConvention= this.selectedDocTypes[0].namingConvention;
    this.selectedDocTypes[0].controlAttributes.length>0?this.isAdditionalInformationBlock=true:this.isAdditionalInformationBlock=false;
    controlAttributes.forEach(formItem => {     
      let controlsDetails=new DynamicFormFieldModel ()
      controlsDetails.id = this.getControlId(formItem.controlName);
      const isTypeOfCertification = controlsDetails.id === 'typeofCertification';
      controlsDetails.type = isTypeOfCertification
        ? 'select'
        : this.normalizeAdditionalControlType(formItem.controlDetail.controlType, formItem.controlName);

      if (controlsDetails.id === 'loadTestRequired' || controlsDetails.id === 'pressureTestRequired') {
        controlsDetails.type = 'checkbox';
      }

      if (
        controlsDetails.id === 'netWeightLbs' ||
        controlsDetails.id === 'grossWeightLbs' ||
        controlsDetails.id === 'actualLoadTestWeightLbs' ||
        controlsDetails.id === 'ratedLiftCapacityLbs' ||
        controlsDetails.id === 'pressurePsi' ||
        controlsDetails.id === 'dimensions'
      ) {
        controlsDetails.type = 'number';
      }

      controlsDetails.label= formItem.controlName;
      controlsDetails.hint=formItem.controlDetail.controlHint;
      if(formItem.controlName || controlsDetails.label == "Solar Part Number"){
       controlsDetails.maxLength = formItem.controlDetail.maxLength?formItem.controlDetail.maxLength:" "
      }
      else {
      controlsDetails.maxLength=formItem.controlDetail.maxLength?formItem.controlDetail.maxLength:100
      }
      const controlData = formItem.controlDetail?.controlData;
      controlsDetails.list = isTypeOfCertification
        ? [...AppConstants.typeOfCertificationOptions]
        : (
            Array.isArray(controlData?.data) ? controlData.data :
            Array.isArray(controlData?.Data) ? controlData.Data :
            Array.isArray(controlData) ? controlData :
            []
          ).map((item) => String(item).trim()).filter((item) => !!item);
      this.dynamicFormFields.push(controlsDetails);      
    })
    
    this.dynamicFormFields.forEach(formItem => {
      const dynamicValidators = [];

      if (formItem.id === 'typeofCertification') {
        dynamicValidators.push(Validators.required);
      }

      if (formItem.type === 'text') {
        if (formItem.id == "solarPartNumber" || formItem.id == "manufacturerName") {
          dynamicValidators.push(Validators.pattern(this.SPECIALCHARSN));
        } else if (formItem.id == "revisionNumber") {
          dynamicValidators.push(Validators.pattern(this.SPECIALCHARRevN));
        } else {
          dynamicValidators.push(Validators.pattern(this.SPECIALCHAR));
        }
      }
       
       this.uploadFileForm.addControl(formItem.id, this.fb.control(       
         formItem.type==='text'||
         formItem.type==='select'||
         formItem.type==='date'||
         formItem.type==='autocomplete'|| 
         formItem.type==='number'?'':null, 

         dynamicValidators
 
     ));   
         
         if(formItem.type==='autocomplete'){         
           this.materialListCopy=formItem.list;
           this.materialList=formItem.list;
         }
        
    })
    
    if (this.editFileMode) {
      this.dynamicFormFields.forEach(formItem => {
        if (formItem.type === this.DATETYPE) {
         let allDates = this.editFileDetailsChildComponents.uiDocumentAttributesDTO.documentAttributes.additionalInformation[formItem.id];
         const formetDate = allDates ?  moment(allDates).format("MM/DD/YYYY HH:mm:ss") : '';
         const currentDate = formetDate ? new Date(formetDate) : '';
         this.uploadFileForm.controls[formItem.id].patchValue(currentDate);
        } else {
          this.uploadFileForm.controls[formItem.id].patchValue(this.editFileDetailsChildComponents.uiDocumentAttributesDTO.documentAttributes.additionalInformation[formItem.id])
        }
      })
    } 
    
    if(this.uploadFileForm.controls.materialComposition){
      this.uploadFileForm.controls.materialComposition.valueChanges.pipe(
        debounceTime(200), distinctUntilChanged()
        ).subscribe((value) => {           
        value? this.materialList= this.materialListCopy.filter(item=>item.toUpperCase().includes(value.toUpperCase())):this.materialList=this.materialListCopy;
        value && this.materialList.length===0? this.invalidMaterial=true: this.invalidMaterial=false;
    });
    }
  
  }

  private getControlId(controlName: string): string {
    const normalizedName = (controlName || '').trim().toLowerCase();

    if (normalizedName.includes('box dimensions')) {
      return 'dimensions';
    }

    if (normalizedName.includes('pressure test required')) {
      return 'pressureTestRequired';
    }

    if (normalizedName.includes('pressure psi')) {
      return 'pressurePsi';
    }

    if (normalizedName === 'type of certification') {
      return 'typeofCertification';
    }

    if (normalizedName === 'tool number (solar part number)') {
      return 'solarPartNumber';
    }

    if (normalizedName === 'solar reject notice (rn) or discrepancy number') {
      return 'rnNumber';
    }

    if (normalizedName === 'rma number') {
      return 'rmaNumber';
    }

    if (normalizedName === 'pd number') {
      return 'pdNumber';
    }

    if (normalizedName === 'tc number (tech connect)') {
      return 'tcNumber';
    }

    if (normalizedName === 'icm number (investigation case management)') {
      return 'icmNumber';
    }

    if (normalizedName === 'rated left capacity(lbs)') {
      return 'ratedLiftCapacityLbs';
    }

    const words = (controlName || '')
      .split(/[^a-zA-Z0-9]+/)
      .map((word) => word.trim())
      .filter((word) => !!word);

    if (words.length === 0) {
      return '';
    }

    return words
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toLowerCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join('');
  }

  private normalizeAdditionalControlType(controlType: string, controlName: string): DynamicFormFieldModel['type'] {
    const normalizedType = (controlType || '').trim().toLowerCase();
    const normalizedName = (controlName || '').trim().toLowerCase();

    if (normalizedName.includes('load test required') || normalizedName.includes('pressure test required')) {
      return 'checkbox';
    }

    if (normalizedType.includes('checkbox')) {
      return 'checkbox';
    }

    if (normalizedType.includes('y/n') || normalizedType.includes('yes/no') || normalizedType.includes('check box')) {
      return 'checkbox';
    }

    if (normalizedType.includes('autocomplete')) {
      return 'autocomplete';
    }

    if (normalizedType.includes('select') || normalizedType.includes('dropdown')) {
      return 'select';
    }

    if (normalizedType.includes('date')) {
      return 'date';
    }

    if (normalizedType.includes('number') || normalizedType.includes('decimal')) {
      return 'number';
    }

    if (normalizedType.includes('text')) {
      return 'text';
    }

    if (normalizedName.includes('box dimensions')) {
      return 'number';
    }

    return 'text';
  }

  resetDynamicFormFields(){
    this.dynamicFormFields.forEach(formItem => {
      this.uploadFileForm.removeControl(formItem.id)
    });
    this.dynamicFormFields=[]; 
  }

  shouldDisplayAdditionalField(fieldId: string): boolean {
    if (fieldId === 'actualLoadTestWeightLbs' || fieldId === 'ratedLiftCapacityLbs') {
      return this.isChecked(this.uploadFileForm?.controls?.loadTestRequired?.value);
    }

    if (fieldId === 'pressurePsi') {
      return this.isChecked(this.uploadFileForm?.controls?.pressureTestRequired?.value);
    }

    return true;
  }

  private isChecked(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized === 'yes' || normalized === 'true';
    }

    return false;
  }

  resetDynamicCommonFormFields(){
      this.dynamicCommonFormFields.forEach(formItem => {
        this.uploadFileForm.removeControl(formItem.id)
      });
      this.dynamicCommonFormFields=[];
  }

  searchaDocTypeByUserInput(userInput: string): void {
    if (!this.docTypesByPath) { return; }
    const sourceList = this.breadCrumb.length > 1
      ? this.docTypesByPath.item1
      : this.docTypesByPath.item2;
    this.docTypesByPath.filterList = sourceList;
    let docResults = sourceList.filter((item) =>
      JSON.stringify(item.displayValue)
        .toLowerCase()
        .includes(userInput.toLowerCase())
    );
    if (userInput.length > 0) {
      this.docTypesByPath.filterList = docResults;
    } else if (this.docTypesByPath.item1.length > 0) {
      this.docTypesByPath.filterList = this.docTypesByPath.item1;
    } else {
      this.docTypesByPath.filterList = this.docTypesByPath.item2;
    }
  }

  private getUploadPathByDocumentType(data: GetFilePathByDocumentType) {    
    this.documentsService
      .getUploadPathByDocumentType(data)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (res: string) => {
          this.filePathToUpload = res;
          if (this.checkDocTypePermission(this.filePathToUpload)) {
              this.hasPermissions = true;
            this.showAdditionalInformation();
          } else {
              this.hasPermissions = false;
          }
          this.isDocTypeLoading = false;
        },
        (err) => {
          console.error('Failed to get upload path by document type', err);
          this.isDocTypeLoading = false;
        }
      );
  }

  private checkDocTypePermission(path): boolean {
    let foldarName: string = path.split("\\")[1].toString();

    return this.documentsService.folderPermission(
      foldarName,
      this.loggedUserDetails,
      true
    );
  }

  private getLogedUser() {
    this.userRepositoryService.loggedUserData$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((user: User) => {
        this.loggedUserDetails = user;
      });
  }

  /*-- material chips add and remove start --*/
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if (value.length > 20) {
      this.tagValueSize = true;
      this.tagLengthSize = false;
    } else if (this.documentTag.length > 6) {
      this.tagValueSize = false;
      this.tagLengthSize = true;
    } else {
      this.tagValueSize = false;
      this.tagLengthSize = false;
      if ((value || '').trim()) {
        if (value.length <= 20) {
          this.documentTag.push(value);
        }
      }
      // Reset the input value
      if (input) {
        input.value = '';
      }
    }
  }

  remove(documentTag: documentTag): void {
    const index = this.documentTag.indexOf(documentTag);

    if (this.documentTag.length < 8) {
      this.tagLengthSize = false;
    }

    if (index >= 0) {
      this.documentTag.splice(index, 1);
      this.tagsHandler.emit(this.documentTag);
    }
  }
   /*-- material chips add and remove end --*/

  // private getMaterialList() {
  //   this.documentsService
  //     .getMaterialMetaData()
  //     .pipe(takeUntil(this.unsubscribe))
  //     .subscribe((response) => {
  //       this.materialList=response;
  //       this.materialListCopy=response
  //       //this.materialList.push(response) = response;
  //     });
  // }
}
